<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card>
          <b-row class="d-flex align-items-center">
            <b-col cols="8">
              <h1 class="font-weight-bolder mb-0">Create In-App Message</h1>
            </b-col>
            <b-col cols="4" class="text-right">
              <b-button size="md" variant="outline-secondary" class="mr-1">
                <span class="text-lg text-nowrap" style="margin-left: 4px"
                  >Cancel</span
                >
              </b-button>
              <b-button size="md" variant="primary">
                <span class="text-lg text-nowrap" style="margin-left: 4px"
                  >Save & Draft</span
                >
              </b-button>
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col cols="12" md="4">
              <h5 class="text-body font-weight-bolder mb-0 mt-1">Message Name</h5>
              <b-form-input
                placeholder="e.g. Weekend Sports Alert"
                v-model="campaignName"
                type="text"
              />

              <h5 class="text-body font-weight-bolder mb-0 mt-1">Description</h5>
              <b-form-textarea
                placeholder="Internal description"
                rows="2"
                v-model="campaignName"
              />
              <h5 class="text-body font-weight-bolder mb-0 mt-1">Message Type</h5>
              <v-select
                :value="option"
                :options="options"
                :reduce="(val) => val.value"
                :clearable="false"
                @input="(val) => (option = val.value)"
                class="w-100"
              />
              <p class="w-100 font-weight-bold mb-0 mt-1">Active Period</p>
              <b-row>
                <b-col cols="6">
                  <flat-pickr
                    id="endDate"
                    v-model="endDate"
                    class="form-control"
                    :config="configDate"
                    placeholder="mm/dd/yyyy"
                  />
                </b-col>
                <b-col cols="6">
                  <flat-pickr
                    id="endDate"
                    v-model="endDate"
                    class="form-control"
                    :config="configTime"
                    placeholder="mm/dd/yyyy"
                  />
                </b-col>
              </b-row>
              <h5 class="text-body font-weight-bolder mb-0 mt-1">Trigger Type</h5>
              <v-select
                :value="option"
                :options="options"
                :reduce="(val) => val.value"
                :clearable="false"
                @input="(val) => (option = val.value)"
                class="w-100"
              />
              <h5 class="text-body font-weight-bolder mb-0 mt-1">Target Audience</h5>
              <v-select
                :value="option"
                :options="options"
                :reduce="(val) => val.value"
                :clearable="false"
                @input="(val) => (option = val.value)"
                class="w-100"
              />
              <h5 class="text-body font-weight-bolder mb-0 mt-1 w-100">Device Type</h5>
              <b-form-group v-slot="{ ariaDescribedby }" class="mt-1">
                <b-form-checkbox-group
                  id="checkbox-group-1"
                  v-model="selected"
                  :options="options"
                  :aria-describedby="ariaDescribedby"
                  name="checkbox-options"
                ></b-form-checkbox-group>
              </b-form-group>
            </b-col>

            <b-col cols="12" md="8" class="">
              <h5 class="text-body font-weight-bolder mb-0 mt-1">Header</h5>
              <b-form-input
                placeholder="We'd Love Your Feedback!"
                v-model="campaignName"
                type="text"
              />
              <h5 class="text-body font-weight-bolder mb-0 mt-1">Message Body</h5>
              <b-form-textarea
                placeholder="Message content"
                rows="4"
                v-model="campaignName"
              />
              <h5 class="text-body font-weight-bolder mb-0 mt-1">Survey Questions</h5>
              <div class="d-flex flex-column mt-1" style="gap: 8px">
                <b-form-input
                  placeholder="Question 1"
                  v-model="campaignName"
                  type="text"
                />
                <b-form-input
                  placeholder="Question 2"
                  v-model="campaignName"
                  type="text"
                />
                <b-form-input
                  placeholder="Question 3"
                  v-model="campaignName"
                  type="text"
                />
              </div>
              <b-button variant="outline-primary" style="margin-top: 8px">
                <feather-icon icon="PlusIcon" />
                <span>Add Question</span>
              </b-button>

              <h5 class="text-body font-weight-bolder mb-0 mt-1">Buttons</h5>
              <div class="d-flex align-items-center" style="gap: 8px">
                <b-form-input
                  placeholder="Button 1 label"
                  v-model="campaignName"
                  type="text"
                />
                <b-form-input
                  placeholder="Button 2 label"
                  v-model="campaignName"
                  type="text"
                />
              </div>

              <div class="mt-4">
                <h5 class="text-body font-weight-bolder mb-0 mt-1">
                  Message Preview
                </h5>
               <b-row>
                 <b-col cols="12" md="7">
                    <b-card
                      border-variant="secondary"
                      bg-variant="light"
                      class="mt-1"
                    >
                      <p class="font-weight-bolder mb-0">
                        We'd Love Your Feedback!
                      </p>
                      <p class="text-muted">
                        Thank you for using our platform! We're constantly working
                        to improve your experience and would appreciate your
                        feedback on your recent betting activity. This will only
                        take a minute of your time.
                      </p>
                      <p class="mb-0">
                        How would you rate your overall experience?
                      </p>
                      <b-form-rating
                        id="rating-inline"
                        inline
                        value="4"
                        no-border
                        class="bg-light p-0"
                        color="#ff8800"
                      ></b-form-rating>
                      <p class="mb-0">What features do you use most frequent</p>
                      <p class="mb-0">Any suggestions for improvement?</p>
                      <div class="d-flex flex-wrap align-items-center my-1" style="gap:8px">
                        <b-badge href="#" variant="secondary">Sports betting</b-badge>
                        <b-badge href="#" variant="secondary">Horse racing </b-badge>
                        <b-badge href="#" variant="secondary">Live streaming</b-badge>
                      </div>
                      <b-form-textarea placeholder="Your feedback" rows="2" />
                      <b-row class="mt-1">
                        <b-col cols="6">
                          <b-button size="sm" variant="primary" class="w-100"
                            >Submit Feedback</b-button
                          >
                        </b-col>
                        <b-col cols="6">
                          <b-button
                            size="sm"
                            variant="outline-secondary"
                            class="w-100"
                            >Maybe later</b-button
                          >
                        </b-col>
                      </b-row>
                    </b-card>
                 </b-col>
               </b-row>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Spinner from "@core/components/Spinner";
import {
  BBadge,
  BButton,
  BCard,
  BCol,
  BPagination,
  BRow,
  BButtonGroup,
  BTable,
  BCardBody,
  BFormInput,
  BMedia,
  BAvatar,
  BProgress,
  BProgressBar,
  BFormTextarea,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BFormGroup,
  BImg,
  BFormCheckboxGroup,
  BFormSelect,
  BFormFile,
  BFormRating,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";

export default {
  components: {
    BBadge,
    BButton,
    BCard,
    BRow,
    BCol,
    BTable,
    BMedia,
    BPagination,
    vSelect,
    Spinner,
    BButtonGroup,
    BTable,
    BCardBody,
    BFormInput,
    BAvatar,
    flatPickr,
    BProgress,
    BProgressBar,
    ValidationProvider,
    ValidationObserver,
    BFormTextarea,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BFormGroup,
    BImg,
    BFormCheckboxGroup,
    BFormSelect,
    FeatherIcon,
    BFormFile,
    BFormRating,
  },
  data() {
    return {
      max: 4,
      value: 2,
      campaignName: "",
      referenceCode: "",
      startDate: "",
      endDate: "",
      desc: "",
      configDate: {
        // dateFormat: 'd-m-Y',
        altFormat: "d-m-Y",
        altInput: true,
        static: true,
      },
      time: "",
      configTime: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
      },
      selected: "first",
      options: [
        { text: "Mobile", value: "first" },
        { text: "Tablet", value: "second" },
        { text: "Desktop", value: "third" },
      ],
      mainProps: {
        blank: true,
        blankColor: "#777",
        width: 32,
        height: 32,
      },
      selected: [],
      optionsCheck: [
        { text: "Homepage Hero", value: "1" },
        { text: "Sidebar", value: "2" },
        { text: "In-App Banner", value: "3" },
        { text: "Email Header", value: "4" },
      ],
    };
  },
  computed: {},
  async mounted() {},
  methods: {},
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
